import { t } from 'i18next';

import { SetAlert } from 'routes/AppContainer/types';
import { LazyRequestPermissionButton } from 'new-components/RequestPermissionButton/LazyRequestPermissionButton';

/**
 * Creates the arguments for setAlert based on error type.
 * Handles special cases like permission errors (H-4000) that require custom UI.
 *
 * @param alertMessage - The message to display in the alert
 * @param alertHeader - Optional header for the alert
 * @param alertOptions - Optional additional alert options
 * @param error - The API error object
 * @returns Arguments array for setAlert function
 */
export const createErrorAlertArgs = ({
  alertMessage,
  alertHeader,
  alertOptions,
  error,
}: {
  alertMessage: Parameters<SetAlert>[1];
  alertHeader?: Parameters<SetAlert>[2];
  alertOptions?: Parameters<SetAlert>[3];
  error: OP.ApiError;
}): Parameters<SetAlert> => {
  switch (error.errorData?.errorCode) {
    // Missing permission error
    case 'H-4000':
      return [
        'error',
        alertMessage,
        t('Missing permission'),
        {
          createAlertButtons: (handleAlertClose: () => void) => [
            <LazyRequestPermissionButton
              key="request-permission"
              routeDescription={error.errorData?.values?.routeDescription}
              missingScopeDescriptions={
                error.errorData?.values?.missingScopeDescriptions
              }
              handleAlertClose={handleAlertClose}
            />,
          ],
        },
      ];
    default:
      return ['error', alertMessage, alertHeader, alertOptions];
  }
};
